// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__22bvi","messages":"Chat_messages__3kG-m","dateDivider":"Chat_dateDivider__1bL6z"};